
import RemoteResult from "@/entities/common/remote_result"
import IdRequest from "@/entities/common/request/id_request"
import MainLogic from "@/logic/main_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class AgbFiliale extends Vue {
  logic: AgbFilialeLogic = null

  mounted() {
    this.logic = new AgbFilialeLogic()
    this.logic.init(MainLogic.getInstance().filiale.filialeId)
  }
}

class AgbFilialeLogic {
  agb: string

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postMember<RemoteResult<string>>(RestPaths.filialeAgb, request).then(
      (response) => {
        if (response.data.success) {
          this.agb = response.data.payload
        }
      }
    )
  }
}
